import { render } from "./NavBar.vue?vue&type=template&id=3a331c4e&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=3a331c4e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1533455392/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a331c4e"]])

export default __exports__